module.exports = __webpack_public_path__ + "static/media/withdrawlf9eaefc521983be588d8c42194985d1f.webp";